import { get } from './../Config/config';


export const UsersUnderMe = {
    get: (data) => get('/users-under-me', { params: data }),

}

